import TableRow3D from './TableRow3D';

export default TableRow3D;
